// يحدّد هل الموظف "عن بُعد" فعّال اليوم أم أن السريان يبدأ غداً (remote_since).
export const useRemoteStatus = (user, branch) => {
  if (user?.work_mode !== "remote") return { active: false, pending: false };
  const since = user.remote_since;
  if (!since) return { active: true, pending: false };
  const tz = branch?.tz_offset_minutes || 0;
  const today = new Date(Date.now() + tz * 60000).toISOString().slice(0, 10);
  const active = today >= since;
  return { active, pending: !active, since };
};
